import { useState } from "react";
import { Faqs } from "../../../shared/faqs";
import { AiFillCaretUp, AiOutlineCaretDown } from "react-icons/ai";
import { FaqContainer, Collapse } from "./help.style";

const Help = () => {
  const [faqs, setFaqs] = useState([...Faqs]);
  const [filteredFaqs, setFilteredFaqs] = useState([]);

  const ToggleVisibility = (open: boolean, index: number) => {
    const faqs__c = [...(filteredFaqs.length > 0 ? filteredFaqs : faqs)];
    faqs__c[index].isOpened = open;
    setFaqs(faqs__c);
  };

  const handleSearch = (e: any) => {
    let query = e.target.value;
    const searchResult = faqs.filter((item) => {
      let splittedTexts = item.question
        .split(" ")
        .map((element) => element.toLowerCase());
      return splittedTexts.includes(query.toLowerCase());
    });

    searchResult.length > 0
      ? //@ts-ignore
        setFilteredFaqs(searchResult)
      : setFilteredFaqs([]);
  };

  return (
    <div>
      <div className="text-lg font-semibold">Help Center</div>
      <div className="mb-7 text-sm text-gray-400">
        Frequently asked questions
      </div>
      <div
        style={{ background: "#3d0052" }}
        className="mb-3 py-3 text-center text-gray-200"
      >
        Frequently Asked Questions
      </div>
      <div>
        <input
          type="text"
          className="mb-7 h-10 w-full rounded border border-solid border-gray-400 px-5 focus:outline-none"
          placeholder="Search help center"
          onChange={(e) => handleSearch(e)}
        />
      </div>
      <FaqContainer className="">
        {(filteredFaqs.length > 0 ? filteredFaqs : faqs).map((item, index) => (
          <div
            className="mb-2 rounded border border-solid px-3 py-3"
            key={item.question}
          >
            <div
              className="flex cursor-pointer"
              onClick={() => ToggleVisibility(!item.isOpened, index)}
            >
              <div className="font-semibold">{item.question}</div>
              <div className="flex flex-1 justify-end">
                {item.isOpened ? (
                  <AiFillCaretUp
                    className="cursor-pointer"
                    // onClick={() => ToggleVisibility(!item.isOpened, index)}
                  />
                ) : (
                  <AiOutlineCaretDown
                    className="cursor-pointer"
                    // onClick={() => ToggleVisibility(!item.isOpened, index)}
                  />
                )}
              </div>
            </div>
            <Collapse
              isOpened={item.isOpened}
              index={1}
              className={`${item.isOpened ? "open" : ""}`}
            >
              <div className="mt-5">
                <embed
                  // preload="metadata"
                  style={{
                    height: "300px",
                    width: "100%",
                    border: "1px solid grey",
                    objectFit: "cover",
                  }}
                  // controls
                  // src="https://drive.google.com/file/d/1a267AV05jEvJ2TYIWGp821_D-igXYhhC/view?pli=1"
                  src={item.videoLink}
                ></embed>
              </div>
            </Collapse>
          </div>
        ))}
      </FaqContainer>
    </div>
  );
};

export default Help;
